/* eslint-disable  */
import React, { useState, useEffect } from "react";
import { TextField, Button, Container, Stack, SvgIcon } from "@mui/material";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
// import axios from "axios";
import Box from "@mui/material/Box";
import { get } from "../library/Api";
import { ToastContainer, toast } from "react-toastify";
import { post } from "../library/Api";
import Tooltip from "@mui/material/Tooltip";
// import { makeStyles } from '@mui/styles';
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import PulseLoader from "react-spinners/PulseLoader";

import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { size } from "lodash";
import { fontSize } from "@mui/system";

const TenantHistory = () => {
  const [openRow, setOpenRow] = useState(null);
  const [historicData, sethistoricData] = useState([]);
  const [customerdata, setcustomerdata] = useState([]);
  const [cust_id, setcustId] = useState("0");
  const [firstName, setFirstName] = useState("");
  const rowsPerPage = 15;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, settotalPage] = useState('0');
  const [filterCustomerdata, setfilterCustomerdata] = useState([]);
  const [initialFilterData,setInitialFilterData] =useState([])

  const rowsPerPage_history = 10;
  const [currentPage_history, setCurrentPageHistory] = useState(1);
  const [totalPage_history, settotalPagehistory] = useState('0');

  const [historicDataLoader, sethistoricDataLoader] = useState(false);
  const [dateFilterData,setDateFilterData] = useState("")
  const [isLoading, setIsLoading] = useState(false);
  const [filtered_historic_data, setfiltered_historic_data] = useState([]);


const onChange = async (e) => {
  const temp_first_name = e.target.value
  setFirstName(temp_first_name);

  // Clear the date filter field when typing in the search input
  // setDateFilterData('');
   // Determine which dataset to filter
  
 
  // var searchData = customerdata.filter((item) => {
  //   if (
  //     JSON.stringify(item)
  //       .toLowerCase()
  //       .indexOf(e.target.value.toLowerCase()) !== -1
  //   ) {
  //     return item;
  //   }
  // });
  

  const customerData = ()=>{
    var searchData = customerdata.filter((item) => {
    if (
      JSON.stringify(item)
        .toLowerCase()
        .indexOf(e.target.value.toLowerCase()) !== -1
    ) {
      console.log("valuee")
      return item;
    }
  });
  
  
  return searchData;
  }

  const dateFilterSearch = ()=>{
      var searchData = initialFilterData.filter((item) => {
    if (
      JSON.stringify(item)
        .toLowerCase()
        .indexOf(e.target.value.toLowerCase()) !== -1
    ) {
      return item;
    }
  });
  
  return searchData;
  }
  const dataToSearch = dateFilterData ? dateFilterSearch() : customerData();

  // if(dataToSearch === customerdata){
//   var searchData = customerdata.filter((item) => {
//     if (
//       JSON.stringify(item)
//         .toLowerCase()
//         .indexOf(e.target.value.toLowerCase()) !== -1
//     ) {
//       console.log("valuee")
//       return item;
//     }
//   });
// }
// else{

//   var searchData = filterCustomerdata.filter((item) => {
//     if (
//       JSON.stringify(item)
//         .toLowerCase()
//         .indexOf(e.target.value.toLowerCase()) !== -1
//     ) {
//       console.log("dateeeee")
//       return item;
//     }
//   });
// }

    setfilterCustomerdata(dataToSearch);

};

const dateFilter = (date) =>{
  if (date) {
    const formattedDate = dayjs(date).format('YYYY-MM-DD');
    console.log("Formatted date selected:", formattedDate);

    // Clear the search input field when selecting a date
    setFirstName('');

   
     // Temporary reset to force re-trigger
     setDateFilterData(""); // Clear the state momentarily
     setTimeout(() => {
       setDateFilterData(formattedDate); // Set the actual value after reset
     }, 0);
  } else {
    // If date is cleared (null), reset the dateFilterData and show all data
    setDateFilterData('');
    // setDateFilterData(""); // Handle case where date is cleared
    if(customerdata){
      setInitialFilterData(customerdata);
      setfilterCustomerdata(customerdata);
    }
  }
}

const disabledFutureDates = (current) => {
   // Disable dates before August 13, 2024, and after today
   const startDate = dayjs('2024-08-13'); // August 13, 2024
   const endDate = dayjs().endOf('day'); // Today's date
   return current && (current < startDate || current > endDate);
};


const history = [
  {
     "modified_by": "Sachin joseph",
     "activity_id": 4,
     "activity_log": "Rfid change from 130:2356 to 120:23456",
     "customer_id": 1137,
     "timestamp": "2024-08-05 06:21:41",
     "admin_id": 1
   },
  {
     "modified_by": "Sachin joseph",
     "activity_id": 4,
     "activity_log": "Rfid change from 130:2356 to 120:23456",
     "customer_id": 1137,
     "timestamp": "2024-08-05 06:21:41",
     "admin_id": 1
   },
 
 ]
// const customer_data =[
//   {'first_name': 'Hank', 'last_name': 'Jones', 'email': 'hank.jones@sample.com', 'company': 'CompanyC', 'flash_account': 'Z9X3F1'},
//   {'first_name': 'Dana', 'last_name': 'Taylor', 'email': 'dana.taylor@sample.com', 'company': 'CompanyF', 'flash_account': 'R4M2P9'},
//   {'first_name': 'Grace', 'last_name': 'Wilson', 'email': 'grace.wilson@sample.com', 'company': 'CompanyA', 'flash_account': 'B5Q7X8'},
//   {'first_name': 'Frank', 'last_name': 'Williams', 'email': 'frank.williams@dummy.com', 'company': 'CompanyD', 'flash_account': 'Y2W8G5'},
//   {'first_name': 'Jane', 'last_name': 'Brown', 'email': 'jane.brown@example.com', 'company': 'CompanyI', 'flash_account': 'T9V4K3'},
//   {'first_name': 'John', 'last_name': 'Smith', 'email': 'john.smith@example.com', 'company': 'CompanyJ', 'flash_account': 'X5H7D2'},
//   {'first_name': 'Mia', 'last_name': 'Doe', 'email': 'mia.doe@dummy.com', 'company': 'CompanyG', 'flash_account': 'F3C8J6'},
//   {'first_name': 'Charlie', 'last_name': 'Garcia', 'email': 'charlie.garcia@example.com', 'company': 'CompanyB', 'flash_account': 'L6Z1E3'},
//   {'first_name': 'Alice', 'last_name': 'Martinez', 'email': 'alice.martinez@dummy.com', 'company': 'CompanyH', 'flash_account': 'Q4P2K9'},
//   {'first_name': 'Liam', 'last_name': 'Lopez', 'email': 'liam.lopez@dummy.com', 'company': 'CompanyE', 'flash_account': 'D8B7M5'},
//   {'first_name': 'Kate', 'last_name': 'Davis', 'email': 'kate.davis@sample.com', 'company': 'CompanyF', 'flash_account': 'N9W3J4'},
//   {'first_name': 'Eve', 'last_name': 'Johnson', 'email': 'eve.johnson@example.com', 'company': 'CompanyA', 'flash_account': 'G2V8F7'},
//   {'first_name': 'Bob', 'last_name': 'Anderson', 'email': 'bob.anderson@sample.com', 'company': 'CompanyD', 'flash_account': 'S4H2K9'},
//   {'first_name': 'Ivy', 'last_name': 'Miller', 'email': 'ivy.miller@dummy.com', 'company': 'CompanyC', 'flash_account': 'K8X5P3'},
//   {'first_name': 'Jack', 'last_name': 'Thomas', 'email': 'jack.thomas@dummy.com', 'company': 'CompanyG', 'flash_account': 'E7D9L1'}
// ]




// {
//   "account": 14864859,
//   "company": "Apache Industrial Services",
//   "customer_id": 1090,
//   "firstName": "Aaron",
//   "lastName": "Dennison"
// },


const handleNextPage = () => {
  if (currentPage < totalPage) {
    setCurrentPage(currentPage + 1);
  }
};

const handleNextPagehistory = () => {
  if (currentPage_history < totalPage_history) {
    setCurrentPageHistory(currentPage_history + 1);
  }
};
const startIndex = (currentPage - 1) * rowsPerPage + 1;
  const endIndex = Math.min(startIndex + rowsPerPage - 1, filterCustomerdata.length);

  const startIndexHistory = (currentPage_history - 1) * rowsPerPage_history + 1;
  // const endIndexHistory = Math.min(startIndexHistory + rowsPerPage_history - 1, historicData.length);
  const endIndexHistory = Math.min(startIndexHistory + rowsPerPage_history - 1, filtered_historic_data.length);

  
  useEffect(() => {
    const temp_totalPages = Math.ceil(filterCustomerdata.length / rowsPerPage);
    settotalPage(temp_totalPages)
  }, [filterCustomerdata]);

  

const handlePreviousPage = () => {
  if (currentPage > 1) {
    setCurrentPage(currentPage - 1);
  }
};

const handlePreviousPagehistory = () => {
  if (currentPage_history > 1) {
    setCurrentPageHistory(currentPage_history - 1);
  }
};

useEffect(()=>{

  if(dateFilterData){
    setIsLoading(true);
    get(`list_tenant_customers_bydate?date=${dateFilterData}`).then((res)=>{
      const responseWithDate = res.data;
      setfilterCustomerdata(responseWithDate)
      setInitialFilterData(responseWithDate)
      console.log("responseWithDate::",responseWithDate);
      setIsLoading(false);
    }).catch(() => {
      setIsLoading(false);
    });
  }

},[dateFilterData]);



useEffect(() => {
  get(`list_tenant_customers`).then((res) => {
    const cus_data = res.data;
    // setCompanyList(res.data.companies);
    setcustomerdata(res.data)
    setfilterCustomerdata(res.data)
    const temp_totalPages = Math.ceil(cus_data.length / rowsPerPage);
    settotalPage(temp_totalPages)
  });
  // setcustomerdata(customer_data)
  // sethistoricData(history)
}, []);



useEffect(() => {
  sethistoricDataLoader(true);
  sethistoricData([]);
  setviewMore(false);
  
  // setCurrentPageHistory()
  // settotalPagehistory('0');
  // setCurrentPageHistory('1');
  
  get(`list_tenant_customer_history/${cust_id}`).then((res) => {
    const data = res;
     sethistoricDataLoader(false)
    // setCompanyList(res.data.companies);
    // setcustomerdata(res.data)
    sethistoricData(res.data)
    const temp_totalPages_history = Math.ceil(res.data.length / rowsPerPage_history);
    settotalPagehistory(temp_totalPages_history)
  });
  // setcustomerdata(customer_data)
 
}, [cust_id]);

const getCurrentPageData = () => {
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  return filterCustomerdata.slice(startIndex, endIndex);
};



// inner table

useEffect(()=>{
  const filteredHistoric_Data = historicData.filter((item)=>Object.keys(item.changes).length !== 0)
  setfiltered_historic_data(filteredHistoric_Data)
},[historicData])


const getCurrentPageData_history = () => {
  const startIndexHistory = (currentPage_history - 1) * rowsPerPage_history;
  const endIndexHistory = startIndexHistory + rowsPerPage_history
  console.log(startIndexHistory,endIndexHistory)
  // const filtered_historic_data = historicData.filter((item)=>Object.keys(item.changes).length !== 0) 
  return filtered_historic_data.slice(startIndexHistory,endIndexHistory);
  // return historicData.slice(startIndexHistory, endIndexHistory);
};


// const meterLogList = meterLogListall.data


const [openModal,setModal] =useState(false);
const [modalContent,setModalContent] = useState("");
const [hoveredRowId, setIsHovered] = useState(null);

const [modalType, setModalType] = useState(null);
const [modalData, setModalData] = useState(null);
const [viewmore,setviewMore] =useState(false);

const [openCreateVehicleModal,setCreateVehicleModal] =useState(false)
const [createdVehicleData, setCreatedVehicleData] = useState({});
const [updatedVehicleData, setUpdatedVehicleData] = useState({
  oldValues: {},
  newValues: {}
});

const [updatedCustomerData, setUpdatedCustomerData] = useState({
  oldValues: {},
  newValues: {}
});

const [openUpdateCustomerModal, setUpdateCustomerModal] = useState(false);


const [openUpdatedVehicleModal,setUpdatedVehicleModal] =useState(false)

const [openCreateCustomerModal,setCreateCustomerModal] =useState(false)
const [createdCustomerData, setCreatedCustomerData] = useState({});

const fieldDisplayNames = {
  Make_Model: "Make & Model",
  Color: "Color",
  License_Plate: "License Plate",
  State: "State",
};

const customerFieldDisplayNames = {
  First_Name: "First Name",
  Last_Name: "Last Name",
  Company: "Company",
  Email: "Email",
  Mobile: "Mobile",
  Building: "Building",
  Garage_Address: "Garage Address",
  Profile: "Profile",
  RFID: "RFID",
  // Vehicles: "Vehicles",
};

const modalstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  padding: "55px 30px",
  borderRadius: "10px",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  // p: 4,
};

const handleViewmoreClick = () =>{
  setviewMore(true)
}
const handleMouseEnter= (id,activity_log,changes) =>{

  if (activity_log === "Vehicle Created") {

    setCreatedVehicleData({
      makeAndModel: changes.Make_Model?.new_value || "",
      vehicleColor: changes.Color?.new_value || "",
      licensePlate: changes.License_Plate?.new_value || "",
      state: changes.State?.new_value || ""
    });
    setModalType("VehicleCreated");

    setModalData(changes);

    setCreateVehicleModal(true);
  } 

  else if (activity_log === "Vehicle Deleted") {
    setCreatedVehicleData({
      makeAndModel: changes.Make_Model?.old_value || "",
      vehicleColor: changes.Color?.old_value || "",
      licensePlate: changes.License_Plate?.old_value || "",
      state: changes.State?.old_value || ""
    });
    setModalType("VehicleDeleted");
    setCreateVehicleModal(true);
  }

  else if (activity_log === "Vehicle Updated") {

    const oldValues = {};
    const newValues = {};

    Object.keys(changes).forEach((field) => {
      oldValues[field] = changes[field].old_value || "";
      newValues[field] = changes[field].new_value || "";
    });

    setUpdatedVehicleData({ oldValues, newValues });
    setModalType("VehicleUpdated");
    setUpdatedVehicleModal(true);

    // setUpdatedVehicleData({
    //   oldValues: {
    //     makeAndModel: changes.Make_Model?.old_value || "",
    //     vehicleColor: changes.color?.old_value || "",
    //     licensePlate: changes.license_plate?.old_value || "",
    //     state: changes.State?.old_value || "",
    //   },
    //   newValues: {
    //     makeAndModel: changes.Make_Model?.new_value || "",
    //     vehicleColor: changes.color?.new_value || "",
    //     licensePlate: changes.license_plate?.new_value || "",
    //     state: changes.State?.new_value || "",
    //   }
    // });
    // setModalType("VehicleUpdated");
    // setUpdatedVehicleModal(true);
  }

  else if (activity_log === "Customer Updated") {

     const oldValues = {};
     const newValues = {};
 
     Object.keys(changes).forEach((field) => {
       oldValues[field] = changes[field].old_value || "";
       newValues[field] = changes[field].new_value || "";
     });
 
     setUpdatedCustomerData({ oldValues, newValues });
     setModalType("CustomerUpdated");
     setUpdateCustomerModal(true);

    // setUpdatedCustomerData({
    //   oldValues: {
    //     firstName: changes.First_Name?.old_value || "",
    //     lastName: changes.Last_Name?.old_value || "",
    //     company: changes.Company?.old_value || "",
    //     email: changes.Email?.old_value || "",
    //     mobile: changes.Mobile?.old_value || "",
    //     building: changes.Building?.old_value || "",
    //     garageAddress: changes.Garage_Address?.old_value || "",
    //     profile: changes.Profile?.old_value || "",
    //     rfid: changes.RFID?.old_value || "",
    //     vehicles: changes.Vehicles?.old_value || "",
    //   },
    //   newValues: {
    //     firstName: changes.First_Name?.new_value || "",
    //     lastName: changes.Last_Name?.new_value || "",
    //     company: changes.Company?.new_value || "",
    //     email: changes.Email?.new_value || "",
    //     mobile: changes.Mobile?.new_value || "",
    //     building: changes.Building?.new_value || "",
    //     garageAddress: changes.Garage_Address?.new_value || "",
    //     profile: changes.Profile?.new_value || "",
    //     rfid: changes.RFID?.new_value || "",
    //     vehicles: changes.Vehicles?.new_value || "",
    //   }
    // });
    // setModalType("CustomerUpdated");
    // setUpdateCustomerModal(true);
  }
  
  else if(activity_log === "Customer Created") {

    setCreatedCustomerData({
      Customer_Id: changes.Customer_Id?.new_value || "",
      building: changes.Building?.new_value || "",
      company: changes.Company?.new_value || "",
      customerId: changes.Customer_Id?.new_value || "",
      email: changes.Email?.new_value || "",
      firstName: changes.First_Name?.new_value || "",
      garageAddress: changes.Garage_Address?.new_value || "",
      lastName: changes.Last_Name?.new_value || "",
      mobile: changes.Mobile?.new_value || "",
      profile: changes.Profile?.new_value || "",
      rfid: changes.RFID?.new_value || "",
      // vehicles: changes.Vehicles?.new_value || "",
    });

    setCreateCustomerModal(true)

    setModalType("CustomerCreated");
    setModalData(changes);
    
  }
  else if(activity_log === "Customer Deleted") {

    setCreatedCustomerData({
      Customer_Id: changes.Customer_Id?.old_value || "",
      building: changes.Building?.old_value || "",
      company: changes.Company?.old_value || "",
      customerId: changes.Customer_Id?.old_value || "",
      email: changes.Email?.old_value || "",
      firstName: changes.First_Name?.old_value || "",
      garageAddress: changes.Garage_Address?.old_value || "",
      lastName: changes.Last_Name?.old_value || "",
      mobile: changes.Mobile?.old_value || "",
      profile: changes.Profile?.old_value || "",
      rfid: changes.RFID?.old_value || "",
      // vehicles: changes.Vehicles?.old_value || "",
    });

    setCreateCustomerModal(true)

    setModalType("CustomerDeleted");
    setModalData(changes);
    
  }
  

  // setModal(true)
  setIsHovered(id)
}

const handleCloseModal = ()=>{
  // setModal(false);
  setCreateVehicleModal(false);
  setCreateCustomerModal(false);
  setUpdatedVehicleModal(false);
  setUpdateCustomerModal(false);
  setIsHovered(null);
}

const formatActivityDate = (timestamp) => {
  const activityDateFormating = new Date(timestamp);
  return activityDateFormating.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
};




const handleRowClick = (name) => {
  // sethistoricDataLoader(true)
  setcustId(name)
  setOpenRow(openRow === name ? null : name);
};


// row click should fetch user history data
  const renderRow = (row, index) => {

    const backgroundColorClass =
      index % 2 === 0 ?   "white-background" : "bg-table-blue" ; 

    return (
      <React.Fragment key={row.customer_id}>
        <TableRow
           onClick={() => handleRowClick(row.customer_id)}
          sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
        >
          {/* <TableCell>
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => handleRowClick(row.name)}
                  > 
                    {openRow === row.name ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                  </IconButton>
                </TableCell> */}

{/* <TableCell
            className={backgroundColorClass}
            component="th"
            // onClick={() => handleRowClick(row.customer_id)}
            scope="row"
          >
            {index}
          </TableCell> */}

          <TableCell
            className={backgroundColorClass}
            component="th"
            // onClick={() => handleRowClick(row.customer_id)}
            scope="row"
          >
            {row.firstName}  
          </TableCell>
          <TableCell
            className={backgroundColorClass}
            component="th"
            // onClick={() => handleRowClick(row.customer_id)}
            scope="row"
          >
            {row.lastName}  
          </TableCell>
          <TableCell
            className={backgroundColorClass}
            component="th"
            onClick={() => handleRowClick(row.first_name)}
            scope="row"
          >
            {row.email}
          </TableCell>
          <TableCell
            className={backgroundColorClass}
            component="th"
            // onClick={() => handleRowClick(row.customer_id)}
            scope="row"
          >
            {row.company}
          </TableCell>
          {/* <TableCell
            className={backgroundColorClass}
            component="th"
            // onClick={() => handleRowClick(row.customer_id)}
            scope="row"
          >
            {row.account}
          </TableCell> */}
                
        </TableRow>

        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            
            <Collapse in={openRow === row.customer_id} timeout="auto" unmountOnExit>
            
              <Box sx={{ margin: 1 }}>
             
                <Typography className="blue_head" variant="h6" gutterBottom component="div">
                  {"Activity Log"}
                </Typography>
                {historicDataLoader === false && historicData.length > 0  ? (<> 
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow className={'bg-table-blue_dark'}> 
                      <TableCell className={'bg-table-blue_dark'} > Activity Date</TableCell>
                      <TableCell className={'bg-table-blue_dark'}>Activity</TableCell>
                      <TableCell className={'bg-table-blue_dark'}>Modified By</TableCell>
                      
                    </TableRow>
                  </TableHead>
                  <TableBody>

                    {/* {startIndexHistory <= 3 ? (<> <h1>sachin</h1> </>) : ""} */}
                    {/*  --1  if start < 3 and total >3 (rows + button ) if viewmore ()*/}
                   
 
                    {startIndexHistory <= 3 && historicData.length > 3 && viewmore === false ? (<> 
                    {getCurrentPageData_history().slice(0,3).map((historyRow) => (
                      <TableRow key={historyRow.created_at}>
                        <TableCell component="th" scope="row">
                          {/* {historyRow.timestamp} */}
                          {formatActivityDate(historyRow.timestamp)}
                        </TableCell>
                        <TableCell component="th" scope="row" 
                        onMouseDown={() => handleMouseEnter(historyRow.activity_id,historyRow.activity_log,historyRow.changes)}
                        style={{ cursor: 'pointer' }}>
                          {historyRow.activity_log} 
                        </TableCell>
                        <TableCell component="th" scope="row" >
                          {/* {historyRow.changed == "Replaced"? `${historyRow.changed} -(${historyRow.replaced_meter_id},${historyRow.replaced_register_number})`: historyRow.changed == "Old" ? "Active" :`${historyRow.changed}`} */}
                          {historyRow.modified_by}
                        </TableCell>
                      </TableRow>
                    ))}  
                       <br />
                      {viewmore === false && ( <div >
                
                        <Button onClick={handleViewmoreClick}
                        variant="outlined" color="secondary" 
                         disabled={false}>
                         View More
                        </Button>
                      </div>  )}
                       

                      {viewmore == true && (<> 
                        {getCurrentPageData_history().map((historyRow) => (
                      <TableRow key={historyRow.created_at}>
                        <TableCell component="th" scope="row">
                          {/* {historyRow.timestamp} */}
                          {formatActivityDate(historyRow.timestamp)}
                        </TableCell>
                        <TableCell component="th" scope="row"
                         onMouseDown={() => handleMouseEnter(historyRow.activity_id,historyRow.activity_log,historyRow.changes)}
                         style={{ cursor: 'pointer' }}>
                          {historyRow.activity_log} 
                        </TableCell>
                        <TableCell component="th" scope="row" >
                          {/* {historyRow.changed == "Replaced"? `${historyRow.changed} -(${historyRow.replaced_meter_id},${historyRow.replaced_register_number})`: historyRow.changed == "Old" ? "Active" :`${historyRow.changed}`} */}
                          {historyRow.modified_by}
                        </TableCell>
                      </TableRow>
                    ))} 
                    
                           {/* <div>
        <Button onClick={handlePreviousPagehistory} disabled={currentPage_history === 1}>
          Previous
        </Button>
        <Button onClick={handleNextPagehistory} disabled={currentPage_history === totalPage_history}>
          Next
        </Button>
      </div> */}
                      </>)}
                      

                    </>) :(<>

                    {/* ------------------ */}
                    {getCurrentPageData_history().map((historyRow) => (
                      <TableRow key={historyRow.created_at}>
                        <TableCell component="th" scope="row">
                          {/* {historyRow.timestamp} */}
                          {formatActivityDate(historyRow.timestamp)}
                        </TableCell>
                        <TableCell component="th" scope="row" 
                        onMouseDown={() => handleMouseEnter(historyRow.activity_id,historyRow.activity_log,historyRow.changes)}
                        style={{ cursor: 'pointer' }}>
                          {historyRow.activity_log} 
                        </TableCell>
                        <TableCell component="th" scope="row" >
                          {historyRow.modified_by}
                        </TableCell>
                      </TableRow>
                    ))}


                     </>)}
                      
                    {/* ---------------------- */}
                  </TableBody>
                </Table>



               {/* {viewmore === true ||  historicData.length < 3  ?(<>  */}
                {viewmore === true ||  filtered_historic_data.length < 3  ?(<> 
                <div>
        <Button onClick={handlePreviousPagehistory} disabled={currentPage_history === 1}>
          Previous
        </Button>
        <Button onClick={handleNextPagehistory} disabled={currentPage_history === totalPage_history}>
          Next
        </Button>
      </div>
      </>) :"" }

      {/* {historicData.length > 1 && (<>  <div className="page-info"> */}
        {filtered_historic_data.length > 1 && (<>  <div className="page-info">
          {/* {startIndexHistory}-{endIndexHistory} out of {historicData.length} */}
          {startIndexHistory}-{endIndexHistory} out of {filtered_historic_data.length}
        </div>
        </>)}

        </>) : historicDataLoader ===true ?( <div style={{ display: 'flex', alignItems: 'center' }}>
                  <PulseLoader 
                  color="#02487B"
                  className="blue_head" size={10} />
                  <span style={{ marginLeft: '8px' }}>Loading...</span>
                </div>) : ( <div style={{ display: 'flex', alignItems: 'center' }}>
                  <CloudOffIcon className="blue_head"/>
                  <span style={{ marginLeft: '8px' }}>Data not available </span>
                </div>)}
              </Box>
                      
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };







  


    return (
        <React.Fragment>
          <ToastContainer />
          {/* <Navbar name="Dashboard" /> */}
          <Box sx={{ display: "flex" }}>
            <Sidebar />

            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            {/* <div className="d-flex align-items-center"> */}
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h3 className="heading-style">Tenant History</h3>
              <div className="d-flex align-items-center">
              <input
                    type="text"
                    placeholder="Search by Name,Company"
                    value={firstName}
                    onChange={(e) => onChange(e)}
                    style={{ width: "290px" }}
                    className="me-4 search-style right_me"
                  />
                   
                 <DatePicker
                  onChange={dateFilter}
                  value={dateFilterData ? dayjs(dateFilterData) : null}
                  format="YYYY-MM-DD"
                  placeholder="Search By Date"
                  className="me-4 search-style right_me custom-date-picker"
                  disabledDate={disabledFutureDates}
                  inputReadOnly
                  allowClear />
                  </div>
                </div>
              

              
              <div style={{background: '#fff', padding: '12px 10px', borderRadius: '15px'}}>
              {isLoading ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "50vh", // centers the loader
      }}
    >
      <PulseLoader color="#02487B" size={15} />
      <p style={{ fontWeight: "bold", color: "#02487B", marginTop: "10px" }}>
        Loading
      </p>
    </div>
  ) : customerdata.length > 0 ? (
    <>
              {/* <div className="container-right">
              <input
                    type="text"
                    placeholder="Search by Name,Company"
                    value={firstName}
                    onChange={(e) => onChange(e)}
                    style={{ width: "290px" }}
                    className="me-4 search-style right_me"
                  />
                   
                 <DatePicker
                  onChange={dateFilter}
                  format="YYYY-MM-DD"
                  placeholder="Search By Date"
                  className="me-4 search-style right_me"
                  inputReadOnly />
                  </div>
                  <br />
                  <br /> */}


{/* {isLoading ? (
                  <div
                    className="table-style"
                    style={{ marginLeft: "46%", marginTop: "20%" }}
                  >
                    <PulseLoader
                      color="#02487B"
                      height={29}
                      margin={4}
                      radius={24}
                      width={4}
                    />
                    <p style={{ fontWeight: "bold", color: "#02487B" }}>
                      Loading
                    </p>
                  </div>
                ) : (
                  <> */}
                <TableContainer component={Paper} className="">
                  <Table aria-label="collapsible table">
        
                    <TableBody>
                    <TableRow
                       className={"bg-table-blue_head"}
                  sx={{ "& > *": { borderBottom: "unset" }, borderRadius: "18px" }}
                  >
                  {/* <TableCell>
                          <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => handleRowClick(row.name)}
                          > 
                            {openRow === row.name ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                          </IconButton>
                        </TableCell> */}

                    {/* <TableCell
                      className={"bg-table-blue_dark"}
                      component="th"
                
                      scope="row"
                    >
                      {"S.No"}
                    </TableCell> */}

                  <TableCell
                    className={"bg-table-blue_head"}
                    component="th"
               
                    scope="row"
                  >
                    {"First Name"}
                  </TableCell>
                  <TableCell
                    className={"bg-table-blue_head"}
                    component="th"
                    scope="row"
                  >
                    {"Last Name"}
                  </TableCell>
                  <TableCell
                    className={"bg-table-blue_head"}
                    component="th"
                    scope="row"
                  >
                    {"Email"}
                  </TableCell>
                  <TableCell
                    className={'bg-table-blue_head'}
                    component="th"
                    scope="row"
                  >
                    {"Company"}
                  </TableCell>
                  {/* <TableCell
                    className={'bg-table-blue_head'}
                    component="th"
                    onClick={() => handleRowClick(row.first_name)}
                    scope="row"
                  >
                    {"Account"}
                  </TableCell> */}
                        
                  </TableRow>

                      {getCurrentPageData().map((row, index) => renderRow(row, index))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <div>
                <Button onClick={handlePreviousPage} disabled={currentPage === 1}>
                  Previous
                </Button>
                <Button onClick={handleNextPage} disabled={currentPage === totalPage}>
                  Next
                </Button>
                </div>
                {customerdata.length > 1 && (
        <div className="page-info">
          {startIndex}-{endIndex} out of {filterCustomerdata.length}
        </div>
      )}
    </>
  ) : (
    <div
    className="table-style"
    style={{ marginLeft: "46%", marginTop: "20%" }}
  >
    <PulseLoader
      color="#02487B"
      height={29}
      margin={4}
      radius={24}
      width={4}
    />
    <p style={{ fontWeight: "bold", color: "#02487B" }}>
      {" "}
      Loading{" "}
    </p>
  </div>
  )}
</div>
        {/* //         )}
                
        // </>
        // ) : (
        //   <>
        //    <PulseLoader/> 
        //    </>)}

        //       </div> */}
              

{/* vehicle create/delete modal end */}

{/* vehicle create/delete modal */}

<Modal
  open={openCreateVehicleModal}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
  className="custom-modal-class"
>
  <Box sx={modalstyle} className="modal-box">
  <IconButton
      aria-label="close"
      onClick={handleCloseModal}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
    <Typography id="modal-modal-title" className="heading-style" variant="h6" component="h2" sx={{ mb: 2 }}>
      {modalType === "VehicleCreated" ? "Vehicle Created" : "Vehicle Deleted"}
    </Typography>

    {/* Table Design */}
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="Vehicle Details Table">
        <TableHead>
          <TableRow>
            <TableCell>Field</TableCell>
            <TableCell >Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              Make & Model
            </TableCell>
            <TableCell >{createdVehicleData.makeAndModel}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              Vehicle Color
            </TableCell>
            <TableCell >{createdVehicleData.vehicleColor}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              License Plate
            </TableCell>
            <TableCell >{createdVehicleData.licensePlate}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              State
            </TableCell>
            <TableCell >{createdVehicleData.state}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>

    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
      <Button variant="contained" onClick={handleCloseModal} sx={{ mt: 2, borderRadius: '19px' }}>
        Close
      </Button>
    </Box>
  </Box>
</Modal>


{/* vehicle create/delete modal end*/}





  {/* Customer created Modal */}
  {/* <Modal
      open={openCreateCustomerModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >

    <Box sx={modalstyle}>
        <Typography id="modal-modal-title" className="heading-style" variant="h6" component="h2" sx={{ mb: 2 }}>
        {modalType == "CustomerCreated" ? "Customer Created" : "Customer Deleted"}
        </Typography>
        <Box className="container">
          <Box className="row">

            <Box className="col-6">
              <div className="d-flex justify-content-between align-items-center">
              <Typography>First Name</Typography>
              <span>:</span>
              </div>
            </Box>
            <Box className="col-6">
              <Typography>{createdCustomerData.firstName}</Typography>
            </Box>
            <Box className="col-6">
            <div className="d-flex justify-content-between align-items-center">
              <Typography>Last Name</Typography>
              <span>:</span>
              </div>
            </Box>
            <Box className="col-6">
              <Typography>{createdCustomerData.lastName}</Typography>
            </Box>
            <Box className="col-6">
            <div className="d-flex justify-content-between align-items-center">
              <Typography>Company</Typography>
              <span>:</span>
              </div>
            </Box>
            <Box className="col-6">
              <Typography>{createdCustomerData.company}</Typography>
            </Box>
            <Box className="col-6">
            <div className="d-flex justify-content-between align-items-center">
              <Typography>Email</Typography>
              <span>:</span>
            </div>
            </Box>
            <Box className="col-6">
              <Typography>{createdCustomerData.email}</Typography>
            </Box>

            <Box className="col-6">
            <div className="d-flex justify-content-between align-items-center">
              <Typography>Mobile</Typography>
              <span>:</span>
            </div>
            </Box>
            <Box className="col-6">
              <Typography>{createdCustomerData.mobile}</Typography>
            </Box>

            <Box className="col-6">
            <div className="d-flex justify-content-between align-items-center">
              <Typography>Building</Typography>
              <span>:</span>
            </div>
            </Box>
            <Box className="col-6">
              <Typography>{createdCustomerData.building}</Typography>
            </Box>

            <Box className="col-6">
            <div className="d-flex justify-content-between align-items-center">
              <Typography>Garage Address</Typography>
              <span>:</span>
            </div>
            </Box>
            <Box className="col-6">
              <Typography>{createdCustomerData.garageAddress}</Typography>
            </Box>

            <Box className="col-6">
            <div className="d-flex justify-content-between align-items-center">
              <Typography>Profile</Typography>
              <span>:</span>
            </div>
            </Box>
            <Box className="col-6">
              <Typography>{createdCustomerData.profile}</Typography>
            </Box>

            <Box className="col-6">
            <div className="d-flex justify-content-between align-items-center">
              <Typography>RFID</Typography>
              <span>:</span>
            </div>
            </Box>
            <Box className="col-6">
              <Typography>{createdCustomerData.rfid}</Typography>
            </Box>

            <Box className="col-6">
            <div className="d-flex justify-content-between align-items-center">
              <Typography>Vehicles</Typography>
              <span>:</span>
            </div>
            </Box>
            <Box className="col-6">
              <Typography>{createdCustomerData.vehicles}</Typography>
            </Box>


          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button variant="contained" onClick={handleCloseModal} sx={{ mt: 2, borderRadius: '19px' }}>
            Close
          </Button>
        </Box>
      </Box>

      </Modal> */}

{/* Customer created Modal End*/}



{/* Vehicle Update modal */}
{/* <Modal open={openUpdatedVehicleModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
  <Box sx={modalstyle}>
    <Typography id="modal-modal-title" className="heading-style" variant="h6" component="h2" sx={{ mb: 2 }}>
      Vehicle Updated
    </Typography>
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', alignItems: 'center' }}>
     
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Field</Typography>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Old Value</Typography>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>New Value</Typography>

     
      {Object.keys(updatedVehicleData.oldValues).map((field) => (
        <React.Fragment key={field}>
          <Typography>{field.charAt(0).toUpperCase() + field.slice(1)}</Typography>
          <Typography>{updatedVehicleData.oldValues[field]}</Typography>
          <Typography>{updatedVehicleData.newValues[field]}</Typography>
        </React.Fragment>
      ))}
    </Box>
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
      <Button variant="contained" onClick={handleCloseModal} sx={{ mt: 2, borderRadius: '19px' }}>
        Close
      </Button>
    </Box>
  </Box>
</Modal> */}

{/* Vehicle Update modal End */}


 {/* Customer created Modal */}

 <Modal
  open={openCreateCustomerModal}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
  className="custom-modal-class"
>
  <Box sx={modalstyle} className="modal-box">
  <IconButton
      aria-label="close"
      onClick={handleCloseModal}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>

    <Typography
      id="modal-modal-title"
      className="heading-style"
      variant="h6"
      component="h2"
      sx={{ mb: 2 }}
    >
      {modalType === "CustomerCreated" ? "Customer Created" : "Customer Deleted"}
    </Typography>

    {/* Table Design */}
    <TableContainer component={Paper}>
      <Table aria-label="Customer Details Table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: '50%' }}>Field</TableCell>
            <TableCell sx={{ width: '50%' }}>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              First Name
            </TableCell>
            <TableCell >{createdCustomerData.firstName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              Last Name
            </TableCell>
            <TableCell >{createdCustomerData.lastName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              Company
            </TableCell>
            <TableCell >{createdCustomerData.company}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              Email
            </TableCell>
            <TableCell >{createdCustomerData.email}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              Mobile
            </TableCell>
            <TableCell >{createdCustomerData.mobile}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              Building
            </TableCell>
            <TableCell>{createdCustomerData.building}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              Garage Address
            </TableCell>
            <TableCell >{createdCustomerData.garageAddress}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              Profile
            </TableCell>
            <TableCell >{createdCustomerData.profile}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              RFID
            </TableCell>
            <TableCell >{createdCustomerData.rfid}</TableCell>
          </TableRow>
          {/* <TableRow>
            <TableCell component="th" scope="row">
              Vehicles
            </TableCell>
            <TableCell >{createdCustomerData.vehicles}</TableCell>
          </TableRow> */}
        </TableBody>
      </Table>
    </TableContainer>

    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
      <Button
        variant="contained"
        onClick={handleCloseModal}
        sx={{ mt: 2, borderRadius: "19px" }}
      >
        Close
      </Button>
    </Box>
  </Box>
</Modal>


  {/* Customer created Modal End*/}



{/* Vehicle Update modal  */}
{/* <Modal open={openUpdatedVehicleModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" className="custom-modal-class">
  <Box sx={modalstyle}  className="modal-box">
  
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography id="modal-modal-title" className="heading-style" variant="h6" component="h2">
        Vehicle Updated
      </Typography>
      <Button onClick={handleCloseModal} sx={{ minWidth: 'auto', p: 0 }}>
        <CloseIcon />
      </Button>
    </Box>

    
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', alignItems: 'center' }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Field</Typography>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Old Value</Typography>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>New Value</Typography>

      {Object.keys(updatedVehicleData.oldValues).map((field) => (
        <React.Fragment key={field}>
          <Typography>{fieldDisplayNames[field] || field}</Typography>
          <Typography>{updatedVehicleData.oldValues[field]}</Typography>
          <Typography>{updatedVehicleData.newValues[field]}</Typography>
        </React.Fragment>
      ))}
    </Box>

    
    <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
      <Button variant="contained" onClick={handleCloseModal} sx={{ borderRadius: '19px' }}>
        Close
      </Button>
    </Box>
  </Box>
</Modal> */}

{/* Vehicle Update modal End  */}


{/* Vehicle Update modal */}
<Modal open={openUpdatedVehicleModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" className="custom-modal-class">
  <Box sx={modalstyle} className="modal-box">

    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography id="modal-modal-title" className="heading-style" variant="h6" component="h2">
        Vehicle Updated
      </Typography>
      <Button onClick={handleCloseModal} sx={{ minWidth: 'auto', p: 0 }}>
        <CloseIcon />
      </Button>
    </Box>

    {/* Table Design */}
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="Vehicle Update Table">
        <TableHead>
          <TableRow>
            <TableCell>Field</TableCell>
            <TableCell >Old Value</TableCell>
            <TableCell >New Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(updatedVehicleData.oldValues).map((field) => (
            <TableRow key={field}>
              <TableCell component="th" scope="row">
                {fieldDisplayNames[field] || field}
              </TableCell>
              <TableCell >{updatedVehicleData.oldValues[field]}</TableCell>
              <TableCell >{updatedVehicleData.newValues[field]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
      <Button variant="contained" onClick={handleCloseModal} sx={{ borderRadius: '19px' }}>
        Close
      </Button>
    </Box>
  </Box>
</Modal>
{/* Vehicle Update modal End */}



{/* Customer Update modal */}

{/* <Modal open={openUpdateCustomerModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
  <Box sx={modalstyle}>
    <Typography id="modal-modal-title" className="heading-style" variant="h6" component="h2" sx={{ mb: 2 }}>
      Customer Updated
    </Typography>
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', alignItems: 'center' }}>
     
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Field</Typography>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Old Value</Typography>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>New Value</Typography>

      {Object.keys(updatedCustomerData.oldValues).map((field) => (
        <React.Fragment key={field}>
          <Typography>{field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' ')}</Typography>
          <Typography>{updatedCustomerData.oldValues[field]}</Typography>
          <Typography>{updatedCustomerData.newValues[field]}</Typography>
        </React.Fragment>
      ))}
    </Box>
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
      <Button variant="contained" onClick={handleCloseModal} sx={{ mt: 2, borderRadius: '19px' }}>
        Close
      </Button>
    </Box>
  </Box>
</Modal> */}
{/* Customer Update modal End*/}

{/* Customer Update Modal */}
<Modal open={openUpdateCustomerModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" className="custom-modal-class">
  <Box sx={modalstyle} className="modal-box">
  
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography id="modal-modal-title" className="heading-style" variant="h6" component="h2">
        Customer Updated
      </Typography>
      <Button onClick={handleCloseModal} sx={{ minWidth: 'auto', p: 0 }}>
        <CloseIcon />
      </Button>
    </Box>

    {/* Table Design */}
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="Customer Update Table">
        <TableHead>
          <TableRow>
            <TableCell>Field</TableCell>
            <TableCell>Old Value</TableCell>
            <TableCell>New Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(updatedCustomerData.oldValues).map((field) => (
            <TableRow key={field}>
              <TableCell component="th" scope="row">
              {customerFieldDisplayNames[field] || field}
              </TableCell>
              <TableCell>{updatedCustomerData.oldValues[field]}</TableCell>
              <TableCell>{updatedCustomerData.newValues[field]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
      <Button variant="contained" onClick={handleCloseModal} sx={{ borderRadius: '19px' }}>
        Close
      </Button>
    </Box>
  </Box>
</Modal>
{/* Customer Update Modal End */}



            </Box>
           
          </Box>
        </React.Fragment>
      );
}

export default TenantHistory;